import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';

export const WINNING_MOMENTS_EXCEED_WARNING =
    'The number of winning moments exceeds the available vouchers. Do you want to continue?';

interface WinningMomentsExceedWarningDialogProps {
    isOpen: boolean;
    onCancel: () => void;
    onContinue: () => void;
}

const WinningMomentsExceedWarningDialog = ({
    isOpen,
    onCancel,
    onContinue,
}: WinningMomentsExceedWarningDialogProps) => (
    <Dialog
        maxWidth='xs'
        open={isOpen}
        onClose={onCancel}
        data-testid='winningMomentsExceedWarningDialog'
    >
        <DialogContent>
            <Typography gutterBottom>
                {WINNING_MOMENTS_EXCEED_WARNING}
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>
                Cancel
            </Button>
            <Button variant='contained' onClick={onContinue} autoFocus>
                Continue
            </Button>
        </DialogActions>
    </Dialog>
);

export { WinningMomentsExceedWarningDialog };
